import fileData from "@/data/file";
import inputData from "@/data/input";
import selectionsData from "@/data/selections";

const { motionArtwork: motionArtworkFileName } = fileData.names;

const { autoComplete: autoCompleteInputType, file: fileInputType } = inputData.types;

const { assetType: assetTypeInputName } = inputData.names;

const { assetType: assetTypeInputLabel, motionArtwork: motionArtworkFileInputLabel } = inputData.labels;

const { motionArtworkTypes: motionArtworkTypesKey } = selectionsData.keys;

const releaseMotionArtworkFormData = [
    {
        col: {
            md: 4,
            xs: 12,
        },
        label: assetTypeInputLabel,
        name: assetTypeInputName,
        selectionKey: motionArtworkTypesKey,
        type: autoCompleteInputType,
    },
    {
        col: {
            md: 4,
            xs: 12,
        },
        label: motionArtworkFileInputLabel,
        name: motionArtworkFileName,
        type: fileInputType,
    },
];

export default releaseMotionArtworkFormData;
